<template>
  <div @click="onClick"
       class="vacancy-location">
    <template v-if="vacancy[3].work_place_country">
      <div :style="`background-image: url('${vacancy[3].work_place_country.flag}')`"
           class="vacancy-location__flag"></div>
      {{ vacancy[3].work_place_country.name }}</template><template v-if="vacancy[3].work_place_country && vacancy[3].work_place_city">,</template>
    {{ vacancy[3].work_place_city && vacancy[3].work_place_city.name }}
  </div>
</template>

<script>
  import filterMixin from "@/mixins/filterMixin"

  export default {
    mixins: [filterMixin],
    name: 'VacancyLocation',
    props: {
      vacancy: Object
    },
    computed: {

    },
    methods: {
      onClick() {
        const countryId = this.$get(this.vacancy, '[3].work_place_country.id')
        const cityId = this.$get(this.vacancy, '[3].work_place_city.id')

        if(!countryId && !cityId) return

        this.setStaticFilters({
          [this.staticFiltersKeys.COUNTRY]: countryId,
          [this.staticFiltersKeys.CITY]: cityId
        })
      }
    }
  }
</script>

<style lang="less">

</style>
